import { cashRegisterRepriceQuoteListener } from '@/store/blotter/workflows/cashRepriceQuote/listeners.ts';
import { registerCancelCashRfsListeners } from '@/store/cash/listeners/cancel-rfs-listeners.ts';
import { registerChangeClientListenersForCash } from '@/store/cash/listeners/change-client-listeners.ts';
import { registerCashChangeCurrenciesForGettingEspLimitsListeners } from '@/store/cash/listeners/change-currencies-get-esp-limits.ts';
import { registerDuplicateCashTradeCaptureListenersForCash } from '@/store/cash/listeners/duplicate-cash-trade-capture-listeners.ts';
import { registerCashGetFixingReferencesForNdf } from '@/store/cash/workflows/ndf-fixing-references/listeners.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';

export function registerCashListeners(startAppListening: StartAppListening): void {
  registerCashChangeCurrenciesForGettingEspLimitsListeners(startAppListening);
  registerCashGetFixingReferencesForNdf(startAppListening);
  registerCancelCashRfsListeners(startAppListening);
  registerChangeClientListenersForCash(startAppListening);
  registerDuplicateCashTradeCaptureListenersForCash(startAppListening);
  cashRegisterRepriceQuoteListener(startAppListening);
}
